import { FoxIconTriangleRight } from 'aui-biz-icons';
import { Collapse } from 'aui';
import type { SupportIconProps } from '../Icon/SupportIconPropsNode';
import SupportIconPropsNode from '../Icon/SupportIconPropsNode';
import type { MdComponentIndexProps } from '../type';
import './accordion.less';

export type MarkdownTabProp = {
  title: string;
  defaultOpen?: boolean;
} & SupportIconProps &
  MdComponentIndexProps;

export function MarkdownAccordion(props: React.PropsWithChildren<MarkdownTabProp>) {
  return (
    <div
      data-markdown-component="x-accordion-container"
      data-first={props['data-first']}
      data-last={props['data-last']}
    >
      <Collapse
        defaultActiveKey={props.defaultOpen ?? true ? '1' : ''}
        expandIcon={({ isActive }) => <FoxIconTriangleRight rotate={isActive ? 90 : 0} />}
      >
        <Collapse.Panel
          key={'1'}
          header={
            <div className="flex gap-1 items-center">
              <SupportIconPropsNode {...props} />
              <span>{props.title}</span>
            </div>
          }
        >
          <div className="markdown-child-root">{props.children}</div>
        </Collapse.Panel>
      </Collapse>
    </div>
  );
}

MarkdownAccordion.attributes = [
  'title',
  'defaultOpen',
  'icon',
  'iconColor',
] as (keyof MarkdownTabProp)[];
MarkdownAccordion.displayName = 'MarkdownAccordion';
